import React from 'react';
import './blog-post.css';
import bowl1 from './pictures/bowl1.jpg';
import bowl2 from './pictures/bowl2.jpg';
import bowl3 from './pictures/bowl3.jpg';



//import reportWebVitals from './reportWebVitals';

const Equity23 = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Member Meeting: Bowling Night Recap</h2>
                    <p className="site-post-meta">January 19, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                        On January 12th, we held our first Member Meeting of the quarter, a bowling night! We met up with the club
                        at the HUB bowling alley and got to play several rounds of bowling together. It truly was such a fun night.
                        Thank you so much to everyone who attended - we hope you had a wonderful time! If you were not able to make
                        it we hope you can make it next time.
                    </p>
                    <img src={bowl1} alt="Women in Computing members bowling"/>
                    <img src={bowl2} alt="Women in Computing members bowling"/>
                    <img src={bowl3} alt="Women in Computing members bowling"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Equity23;